/**
 * Commaxx - Compare teller fix voor Enterprise theme
 *
 * Aanpak: valideer de localStorage lijst via de Shopify product API
 * in plaats van de DOM, zodat de fix werkt op elke pagina.
 */

(function () {
  const STORAGE_KEY = 'cc-compare-products';

  function getStoredProducts() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  function updateCounter(count) {
    // Zoek alle teller-elementen die het theme gebruikt
    const selectors = [
      '[data-compare-count]',
      '.compare-count',
      '.cc-compare-count',
      '[data-cc-compare-count]'
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = count;
      });
    });

    // Stuur events zodat het theme zelf ook kan reageren
    window.dispatchEvent(new CustomEvent('compare:updated'));
    document.dispatchEvent(new CustomEvent('compare:count:update', { detail: { count } }));
  }

  async function validateAndFix() {
    const stored = getStoredProducts();
    if (!stored) return;

    // Haal elk product op via de Shopify product API (/products/{id}.js)
    // Dit werkt op elke pagina, onafhankelijk van de DOM
    const validProducts = [];

    await Promise.all(
      stored.map(async (item) => {
        const handle = item.handle || item.url?.split('/products/')?.[1]?.split('?')?.[0];
        if (!handle) {
          // Geen handle beschikbaar, verwijder dit item
          return;
        }

        try {
          const res = await fetch(`/products/${handle}.js`, { method: 'HEAD' });
          if (res.ok) {
            validProducts.push(item);
          }
          // 404 = product bestaat niet meer → niet toevoegen
        } catch (e) {
          // Bij netwerk error: bewaar het product (geen vals negatief)
          validProducts.push(item);
        }
      })
    );

    // Sorteer terug in originele volgorde
    const originalOrder = stored.map(s => s.handle || s.id);
    validProducts.sort((a, b) => {
      return originalOrder.indexOf(a.handle || a.id) - originalOrder.indexOf(b.handle || b.id);
    });

    // Schrijf gecleande lijst terug als er iets veranderd is
    if (validProducts.length !== stored.length) {
      if (validProducts.length === 0) {
        localStorage.removeItem(STORAGE_KEY);
      } else {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(validProducts));
      }
      updateCounter(validProducts.length);
    }
  }

  function init() {
    validateAndFix();
  }

  // Eerste paginaload
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ajax / instant page navigatie
  document.addEventListener('page:load', init);
  document.addEventListener('page:change', init);
  window.addEventListener('popstate', init);

})();